<template>
  <div
    class="flex w-full sm:w-1/2 md:w-1/3 lg:w-1/4 xl:w-1/5"
    @click="visitCategory"
  >
    <a class="card card-content card--interactive text-center">
      <div class="flex-item">
        <h3 class="mb-1">
          <a
            :href="category._links.frontend.self"
            class="no-underline"
            v-text="category.attributes.title"
          />
        </h3>
        <h5
          class="mt-0 mb-4 uppercase"
          v-text="`${category.meta.discussion_count} Discussions`"
        />
        <button
          v-can="'edit-discussion-categories'"
          class="btn btn--sm btn--icon-only icon icon--small"
          @click.stop="$store.commit('discussionCategoryModalOpen', category)"
        >
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="9"
            height="15"
            viewBox="0 0 9 15"
          >
            <path d="M7.67 2.48l.66-1.23L6.25.21 5.56 1.5zm-2.35-.54L.48 10.95l2.11.98 4.84-9.01zM.31 11.43L.1 14.11l2.21-1.75z" />
          </svg>
        </button>
      </div>
    </a>
  </div>
</template>

<script type="text/babel">
export default {
  name: 'DiscussionCategory',
  props: {
    category: {
      type: Object,
      required: true,
    },
  },
  methods: {
    visitCategory() {
      window.location = this.category._links.frontend.self
    },
  },
}
</script>
